import React from 'react';
import type { PreviewData } from './types';

interface EmptyStateProps {
  previewData: PreviewData | null;
  isMimicking: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ previewData, isMimicking }) => {
  return (
    <div
      className={`min-h-screen flex items-center justify-center bg-gray-50 ${
        isMimicking ? 'mt-[52px]' : ''
      }`}
    >
      <div className="text-center max-w-md mx-auto px-4">
        <div className="bg-gray-100 rounded-lg p-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-2">
            {previewData?.page?.title || 'Page Preview'}
          </h2>
          <p className="text-gray-600">This page doesn't have any visible components yet.</p>
        </div>
      </div>
    </div>
  );
};
